import {applyMiddleware, createStore} from "redux"
import {createEpicMiddleware} from "redux-observable"
import rootReducer, {AppState} from "../reducers/rootReducer"
import rootEpic from "../epics/rootEpic"
import {AllActions} from "../actions/actions"

// eslint-disable-next-line import/prefer-default-export
export function configureStore() {
    const epicMiddleware = createEpicMiddleware<
        AllActions,
        AllActions,
        AppState
    >()

    const store = createStore(rootReducer, applyMiddleware(epicMiddleware))
    epicMiddleware.run(rootEpic)
    return store
}
